module.exports = __webpack_public_path__ + "img/28.e6369c0b.png";